import React, { useEffect } from "react";
import HomeToolBar from "./home-toolbar";
import HomeTabs from "./home-tabs";
import usePreviewStore from "../../store/preview-store";
import useOrderStore from "../../store/order-store";
import useResultStore from "../../store/result-store";
import useModelStore from "../../store/model-store";
const Home = () => {
  const { reset: resetPreview } = usePreviewStore();
  const { reset: resetOrder } = useOrderStore();
  const { reset: resetResult } = useResultStore();
  const { resetModel } = useModelStore();
  useEffect(() => {
    resetPreview()
    resetOrder()
    resetResult()
    resetModel()
  }, [])
  
  return (
    <div>
      <HomeToolBar />
      <HomeTabs/>
    </div>
  );
};

export default Home;
